import { FC, Ref, useEffect, useImperativeHandle, useState } from 'react'
import {
  useActiveTooltipCoordinate,
  useActiveTooltipDataPoints,
  useYAxisScale,
} from 'recharts'

import { ChartData, ChartItemWitSelection } from 'types'

import { findHoveredPoint, HoveredPoint } from './findHoveredPoint'

const MAX_POINTER_DISTANCE = 12

export type LineChartHoverTrackerHandle = {
  setPointerX: (pointerX: number) => void
}

type LineChartHoverTrackerProps = {
  charts: ChartItemWitSelection[]
  additionCharts: ChartItemWitSelection[]
  ref?: Ref<LineChartHoverTrackerHandle>
  onChange: (point?: HoveredPoint) => void
}

export const LineChartHoverTracker: FC<LineChartHoverTrackerProps> = ({
  ref,
  charts,
  additionCharts,
  onChange,
}) => {
  const [pointerX, setPointerX] = useState<number>()
  const coordinate = useActiveTooltipCoordinate()
  const payload = useActiveTooltipDataPoints<ChartData[0]>()?.[0]
  const yScale = useYAxisScale()

  useImperativeHandle(ref, () => ({ setPointerX }), [])

  const hoveredPoint =
    payload && yScale && coordinate && pointerX !== undefined
      ? findHoveredPoint({
          payload,
          pointer: { x: pointerX, y: coordinate.y },
          pointX: coordinate.x,
          charts,
          additionCharts,
          getPixelY: yScale,
          maxDistance: MAX_POINTER_DISTANCE,
        })
      : undefined

  useEffect(() => {
    onChange(hoveredPoint)
  }, [hoveredPoint, onChange])

  return null
}
